import { defineMessages } from 'react-intl';

export default defineMessages({
    VehicleChangesHeader: {
        id: 'cep.components.sgEndorsementQuotePage.VehicleChangesHeader',
        defaultMessage: 'Your cover changes'
    },
    VehicleChange: {
        id: 'cep.components.sgEndorsementQuotePage.VehicleChange',
        defaultMessage: 'Changed car to: {vehicle}'
    },
    RegChange: {
        id: 'cep.components.sgEndorsementQuotePage.RegChange',
        defaultMessage: 'Changed registration number to: {registration}'
    },
    OnExistingVehicle: {
        id: 'cep.components.sgEndorsementQuotePage.OnExistingVehicle',
        defaultMessage: 'On your existing vehicle: {make} {model}'
    },
    ModificationAdded: {
        id: 'cep.components.sgEndorsementQuotePage.ModificationAdded',
        defaultMessage: 'Added modification: {modification}'
    },
    ModificationRemoved: {
        id: 'cep.components.sgEndorsementQuotePage.ModificationRemoved',
        defaultMessage: 'Removed modification: {modification}'
    },
    MileageChange: {
        id: 'cep.components.sgEndorsementQuotePage.MileageChange',
        defaultMessage: 'Change mileage to: {mileage}'
    },
    VehicleUseChange: {
        id: 'cep.components.sgEndorsementQuotePage.VehicleUseChange',
        defaultMessage: 'Changed use of car to: {use}'
    },
    VehicleParkingChange: {
        id: 'cep.components.sgEndorsementQuotePage.VehicleParkingChange',
        defaultMessage: 'Changed parking type to: {parking}'
    }
});
